<template>
  <section class="bg-yellow-500 py-4">
    <div class="grid-container">
      <div class="col-span-12 grid grid-cols-2 items-center justify-items-center tablet:grid-cols-5">
        <img src="~/assets/images/partners/pinterest.svg" />
        <img src="~/assets/images/partners/audi.svg" />
        <img src="~/assets/images/partners/slack.svg" />
        <img src="~/assets/images/partners/zalando.svg" />
        <img src="~/assets/images/partners/otto.svg" />
        <img src="~/assets/images/partners/thetradedesk.svg" />
        <img src="~/assets/images/partners/moia.png" />
        <img src="~/assets/images/partners/tchibo.svg" />
        <img src="~/assets/images/partners/universal.svg" />
        <img src="~/assets/images/partners/philipmorris.svg" />
      </div>
    </div>
  </section>
</template>
